import {useStaticQuery, graphql} from "gatsby"

const useProjectQuery = () => {
  const {allDatoCmsProject, allDatoCmsSector, allDatoCmsServicesTag, allDatoCmsLocation} = useStaticQuery(graphql`
    query Project {
      allDatoCmsSector (
        sort: {title: ASC}
      ) {
        nodes {
          title
        }
      }
      allDatoCmsServicesTag(
        sort: {title: ASC}
      ) {
        nodes {
          title
        }
      }
      allDatoCmsLocation(
        sort: {position: ASC}
      ) {
        nodes {
          title
        }
      }
      allDatoCmsProject(
        sort: {position: ASC}
      ) {
        nodes {
          title
          slug
          permalink
          department
          thumbnail {
            ...InternalAssetProps
          }
          sectors {
            title
          }
          servicesTags {
            title
          }
          locations {
            title
          }
        }
      }
    }
`)

  return {allDatoCmsProject, allDatoCmsSector, allDatoCmsServicesTag, allDatoCmsLocation}
}

export default useProjectQuery